/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
} from './InvoiceStatus';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
} from './PaymentType';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Voucher } from './Voucher';
import {
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './Voucher';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    readonly id?: string;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof Invoice
     */
    status?: InvoiceStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    requestStatusChange?: boolean;
    /**
     * 
     * @type {PaymentType}
     * @memberof Invoice
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    readonly invoiceNumber?: string;
    /**
     * 
     * @type {Price}
     * @memberof Invoice
     */
    totalAmount?: Price;
    /**
     * 
     * @type {Array<Voucher>}
     * @memberof Invoice
     */
    vouchers?: Array<Voucher>;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    readonly invoiceDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    readonly due?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    readonly periodFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    readonly periodTo?: Date;
}

/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : InvoiceStatusFromJSON(json['status']),
        'requestStatusChange': !exists(json, 'requestStatusChange') ? undefined : json['requestStatusChange'],
        'paymentType': !exists(json, 'paymentType') ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : PriceFromJSON(json['totalAmount']),
        'vouchers': !exists(json, 'vouchers') ? undefined : ((json['vouchers'] as Array<any>).map(VoucherFromJSON)),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (new Date(json['invoiceDate'])),
        'due': !exists(json, 'due') ? undefined : (new Date(json['due'])),
        'periodFrom': !exists(json, 'periodFrom') ? undefined : (new Date(json['periodFrom'])),
        'periodTo': !exists(json, 'periodTo') ? undefined : (new Date(json['periodTo'])),
    };
}

export function InvoiceToJSON(value?: Invoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': InvoiceStatusToJSON(value.status),
        'requestStatusChange': value.requestStatusChange,
        'paymentType': PaymentTypeToJSON(value.paymentType),
        'totalAmount': PriceToJSON(value.totalAmount),
        'vouchers': value.vouchers === undefined ? undefined : ((value.vouchers as Array<any>).map(VoucherToJSON)),
    };
}

